module.exports = __webpack_public_path__ + "assets/img/niuMo.6af59ccf.png";